import React from 'react';

const FormField = ({ label, required = false, error = null, children, className = '', ...props }) => {
    return (
        <div className={`flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3 ${className}`}>
            <label className="flex flex-col min-w-40 flex-1">
                <p className="text-[#121317] text-base font-medium leading-normal pb-2">
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </p>
                {children}
                {/* Always reserve space for error messages to prevent layout shift */}
                <div className="h-6 mt-1">{error && <p className="text-red-500 text-sm">{error}</p>}</div>
            </label>
        </div>
    );
};

export default FormField;
